<template>
<Navbar v-if="this.lang == 'id'"></Navbar>
<NavbarEn v-else-if="this.lang == 'en'"></NavbarEn>

    <div class="berita-detail">
        <div class="header-db">
			
		</div>

        <div class="container">
            <div class="b-box">
                <div class="row">
                    <div class="col-lg-8 col-md-12">
						<div v-for="data in berita" :key="data.id">
							<div class="detail-b" v-if="data.id">
								<img :src="noImage" class="berita-img" alt="" v-if="data.image === null">
								<img :src="imageUrl+data.image" class="berita-img" alt="" v-else>

								<p>
									<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
										<g id="clock" transform="translate(-2.5 -2.5)">
											<path id="Path_213" data-name="Path 213" d="M14,8.5A5.5,5.5,0,1,1,8.5,3,5.5,5.5,0,0,1,14,8.5Z" fill="none" stroke="#a2a2a2" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
											<path id="Path_214" data-name="Path 214" d="M18,9v3.3l2.2,1.1" transform="translate(-9.5 -3.8)" fill="none" stroke="#a2a2a2" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
										</g>
									</svg>
									<span class="icon"></span>
									<span>{{ dateTime(berita.created_at) }}</span>
								</p>

								<div v-if="this.lang == 'en'">
									<h3 class="title dark-grey">
										{{data.judul_berita_en}}
									</h3>
									<p class="desc" v-html="data.deskripsi_en"></p>
								</div>
								<div v-else-if="this.lang == 'id'">
									<h3 class="title dark-grey">
										{{data.judul_berita}}
									</h3>
									<p class="desc" v-html="data.deskripsi"></p>
								</div>

							</div>
						</div>
                    </div>
                    <div class="col-lg-4 col-md-12">
						<div class="next-b">
							<h5 class="title-b dark-grey" v-if="this.lang == 'en'">More News</h5>
							<h5 class="title-b dark-grey" v-else-if="this.lang == 'id'">Berita Lainnya</h5>

							<!-- Berita 1 -->
							<div v-for="beritaSaya in beritas.slice().reverse()" v-bind:key="beritaSaya.id">
								<News v-bind:beritaSaya="beritaSaya" @click="load()"/>
							</div>
								
						</div>
					</div>

                </div>
            </div>
        </div>
		<div class="langApp">
			<div class="btn-group dropstart">
				<button type="button" class="btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
					<svg xmlns="http://www.w3.org/2000/svg" width="26.442" height="30.849" viewBox="0 0 26.442 30.849">
						<path id="Icon_metro-language" data-name="Icon metro-language" d="M16.028,20.761q-.017.052-.215-.009t-.542-.2l-.344-.155a10.314,10.314,0,0,1-1.5-.844q-.121-.086-.706-.542t-.654-.491a29.327,29.327,0,0,1-2.307,3.116,12.8,12.8,0,0,1-1.808,1.894,1.364,1.364,0,0,1-.336.069.663.663,0,0,1-.318,0q.1-.069,1.412-1.584.362-.413,1.472-1.98a24.068,24.068,0,0,0,1.351-2.031q.293-.516.878-1.7a13.418,13.418,0,0,0,.62-1.334,14.146,14.146,0,0,0-1.894.568q-.138.034-.473.129t-.594.164a2.949,2.949,0,0,0-.293.086.293.293,0,0,0-.034.181.382.382,0,0,1-.017.164q-.086.172-.534.258a1.388,1.388,0,0,1-.809,0,.726.726,0,0,1-.482-.362.876.876,0,0,1-.086-.4,3.327,3.327,0,0,1,.422-.086,5.14,5.14,0,0,0,.508-.1q1-.275,1.808-.551,1.721-.6,1.756-.6a3.819,3.819,0,0,0,.74-.336,7.787,7.787,0,0,1,.757-.37q.155-.052.37-.138t.25-.095a.231.231,0,0,1,.1.009,1.959,1.959,0,0,1-.017.568,3.665,3.665,0,0,1-.215.465q-.215.43-.456.921t-.293.577a25.819,25.819,0,0,1-1.326,2.255l1.1.482q.207.1,1.282.551l1.162.482q.069.017.181.439a1.3,1.3,0,0,1,.077.525ZM12.5,12.395a.7.7,0,0,1-.069.482,1.56,1.56,0,0,1-.861.654,2.764,2.764,0,0,1-1.033.207,1.425,1.425,0,0,1-.844-.448,1.3,1.3,0,0,1-.31-.706l.017-.052a.737.737,0,0,0,.336.086,1.5,1.5,0,0,0,.456,0q.172-.034,1-.275a4.915,4.915,0,0,1,.947-.241.34.34,0,0,1,.362.293Zm12.016,2.221L25.6,18.523,23.207,17.8ZM5.441,28.387l11.947-3.994V6.628L5.441,10.639V28.387ZM26.8,22.93l1.756.534-3.116-11.31-1.721-.534L20,20.847l1.756.534.775-1.894,3.632,1.119ZM18.146,6.369,28.01,9.537V3ZM23.5,29.144l2.72.224-.93,2.754L24.6,30.986a12.761,12.761,0,0,1-4.751,1.859,8.25,8.25,0,0,1-1.567.207H16.837a11.635,11.635,0,0,1-3.434-.671,11.431,11.431,0,0,1-3.159-1.463.359.359,0,0,1-.138-.275.333.333,0,0,1,.086-.232.288.288,0,0,1,.224-.095.969.969,0,0,1,.31.129l.525.284q.284.155.353.189a15.252,15.252,0,0,0,2.746,1.059,10.031,10.031,0,0,0,2.711.422,14.69,14.69,0,0,0,2.875-.25,14.188,14.188,0,0,0,2.7-.869q.258-.121.525-.267t.585-.327q.318-.181.491-.284ZM31.211,10.57V29.144L17.887,24.91q-.241.1-6.455,2.195T5.1,29.2a.311.311,0,0,1-.31-.224.132.132,0,0,0-.017-.052V10.363a.768.768,0,0,1,.069-.172A.774.774,0,0,1,5.183,10q1.825-.6,2.565-.861V2.531l9.606,3.408q.034,0,2.763-.947t5.44-1.868q2.711-.921,2.78-.921.344,0,.344.362v7.2Z" transform="translate(-4.77 -2.203)" fill="#0054a5"/>
					</svg>
				</button>
				<ul class="dropdown-menu">
					<a @click="selectLanguage('id')" v-bind:class="'lang-link' + [activeLanguage === 'id' ? ' link__active' : '']">IDN</a>
					<a @click="selectLanguage('en')" v-bind:class="'lang-link' + [activeLanguage === 'en' ? ' link__active' : '']">ENG</a>

				</ul>
			</div>
		</div>
    </div>
    <Footer />
</template>

<script>
// @ is an alias to /src
import Footer from '@/components/Footer.vue'
import Navbar from '@/components/Navbar.vue'
import NavbarEn from '@/components/NavbarEn.vue'
import News from '@/components/News.vue'

import axios from 'axios'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'

import moment from "moment";

export default {
    name: 'Berita-detail',
    components: {
        Footer,
		News,
		Navbar,
		NavbarEn
    },
	
	setup() {
		let berita = ref([]);
		let beritas = ref([]);
		
		const route = useRoute();

		onMounted(() => {
			axios.get(`getBerita/${route.params.id}`)
			.then((result) => {
				berita.value = result.data
			}).catch((err) => {
				console.log(err.response)
			})
		}),
		onMounted(() => {
			axios.get('getBerita')
			.then((result) => {
				beritas.value = result.data
			}).catch((err) => {
				console.log(err.response)
			})
		})

		return{
			berita,
			beritas
		}
	},
	data() {
        return {
            activeLanguage: this.lang
        }
    },
	methods: {
		dateTime(value) {
			return moment(value).format("DD-MM-YYYY h:mm A");
		},
		selectLanguage: function (lang) {
            this.activeLanguage = lang;
            this.lang = lang;
            
            localStorage.setItem("lang", lang);
        },
		load(load){
            this.load = load;
			location.reload()
        }
	}
}
</script>

<style>
    .header-db{
		background: url(../assets/bg-decor.svg), var(--primary-g);
		background-size: cover;
		padding-top: 200px;
		padding-bottom: 200px;
	}

    .b-box{
        margin-top: -100px;
        background: white;
        padding: 30px;
    }
    .b-box .detail-b h3.title{
        font-weight: 700;
    }
    .b-box .detail-b img.berita-img{
        width: 100%;
        border-radius: 5px;
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
		margin-bottom: 20px;
    }
    .b-box .detail-b p{
		color: #a2a2a2;
        /* padding-top: 25px; */
        /* padding-bottom: 20px; */
	}
	.b-box .detail-b p.desc{
		text-align: justify;
	}
	.b-box .detail-b p svg{
		width: 14px;
		height: 14px;
		margin-right: 5px;
	}

    .next-b {
        border-top: 5px solid var(--secondary-);
        box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
        padding: 10px;
    }
    .next-b h5.title-b{
        font-weight: 600;
        padding-bottom: 15px;
    }

    a.l-b{
		text-decoration: none;
	}
	a.l-b:hover > .b-list{
		border: 1px solid var(--secondary-);
	}
	a.l-b .b-list{
		background: white;
		display: flex;
		border: 1px solid white;
		transition: 0.3s ease-in-out;
        margin-top: 15px;
	}
	a.l-b .b-list .thumb{
		width: 150px;
	}
	a.l-b .b-list .thumb img{
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
	a.l-b .b-list .content{
		padding: 20px 10px 0;
		width: 80%;
	}
	a.l-b .b-list .content h5{
		text-decoration: none;
		color: var(--dark-grey-);
		font-weight: 600;
	}
	a.l-b .b-list .content h5:hover{
		color: var(--secondary-);
	}

	a.l-b .b-list .content p{
		color: #a2a2a2;
		padding-top: 15px;
	}
	a.l-b .b-list .content p svg{
		width: 16px;
		height: 16px;
		margin-right: 5px;
	}
	@media (max-width: 768px){
		.next-b{
			margin-top: 20px;
			border-top: 2px solid var(--secondary-);
			box-shadow: none;
			width: 120%;
			margin-left: -10%;
		}
	}
</style>